import { useContext, useMemo } from "react"
import PropTypes from "prop-types"
import PeriodDisplay from "connected-components/dashboard/components/period-display"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { getFactorCategoryDropdownOptions } from "connected-components/asset-view/helpers/header-dropdown-options"
import { useSourceTemplateMetricIds } from "connected-components/asset-view/hooks/use-source-displayed-metrics"
import { PERFORMANCE_CONTEXT } from "./context"

export default function PerformanceHeader({ modelMetadata, context, flattenedMetrics, onMetricsChange }) {
  const performanceContext = useContext(PERFORMANCE_CONTEXT)
  const { selectedMetricDisplay, setSelectedMetricDisplay, selectedCategory, setSelectedCategory } = performanceContext

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const metricOptions = useMemo(
    () => ({ prefix: "performance", selectedCategory, selectedMetricDisplay }),
    [selectedCategory, selectedMetricDisplay],
  )

  useSourceTemplateMetricIds({ flattenedMetrics, onMetricsChange, metricOptions, includeSummaryRows: true })

  const displayOptions = useMemo(() => METRIC_OPTIONS.performance.map(({ id, label, isDefault, secondaryText, tooltip }) => ({ id, primaryText: label, isDefault, secondaryText, tooltip })), [])

  const categoryOptions = useMemo(
    () => getFactorCategoryDropdownOptions(modelMetadata),
    [modelMetadata],
  )

  return <>
    <PeriodDisplay context={context} />
    <ListItemDropDown
      label="Metric Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
      disablePortal
    />
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

PerformanceHeader.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  flattenedMetrics: PropTypes.object,
  onMetricsChange: PropTypes.func,
}
